module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_08.9ccc568f.svg";